export class ReviewFormLabel_EN {

    review: {
        personal: string;
        income: string;
        loan: string;
    }

    thankyou:{
        caption1: string;
        caption2: string;
        caption3: string;
        caption4: string;
        caption5: string;
        caption6: string;
        caption7: string;
        caption8: string;
        caption9: string;
    }

    constructor() {

        this.review = {
            personal: "Personal",
            income: "Income",
            loan: "Loan"
        }

        this.thankyou = {
            caption1: "Thank you for choosing Renault & Renault Finance.",
            caption2: "We value your decision of choosing Renault Finance as your trusted finance partner.",
            caption3: "We would like you to know that our Online Finance Journey is solely created for your ease, comfort, Safety and most",
            caption4: "importantly – your happiness!",
            caption5: "Your loan application is currently being processed & our executive will get in touch with you shortly.",
            caption6: "Attention: Please do not consider this as an approval for loan.",
            caption7: "We thank you once again for your time and effort.",
            caption8: "To continue exploring Renault world",
            caption9: "click here",
        }
    }
}